/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  dollarize util
 */

import { isNumber, numberize } from './index' // prepend dollar sign

export const dollarize = (price?: any): string => {
  if (isNumber(price)) {
    return `$${numberize(Math.floor(Number(price)))}`
  }

  return ''
}
